import { ENV } from "../utils";

export class Employee {
  baseApi = ENV.BASE_API;

  async getEmployees(accessToken, filters = {}) {
    const params = new URLSearchParams();
    if (filters.active !== undefined) params.append("active", filters.active);
    if (filters.site)  params.append("site",  filters.site);
    if (filters.area)  params.append("area",  filters.area);
    const url = `${this.baseApi}/employees?${params.toString()}`;
    const response = await fetch(url, { headers: { Authorization: `Bearer ${accessToken}` } });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async createEmployee(accessToken, data) {
    const response = await fetch(`${this.baseApi}/add-employee`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async updateEmployee(accessToken, id, data) {
    const response = await fetch(`${this.baseApi}/update-employee/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async deleteEmployee(accessToken, id) {
    const response = await fetch(`${this.baseApi}/delete-employee/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async bulkImportEmployees(accessToken, employees, site) {
    const response = await fetch(`${this.baseApi}/employees/bulk-import`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify({ employees, site }),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
